export default {
  chooseLanguage: 'Velg språk',
  address: 'Besøk oss',
};
